/**
 * @file RelatedKeywordsEditor.tsx
 * @description Custom cell editor for handling related keywords input in AG Grid.
 * Manages keyword input, addition, removal, and state synchronization within the grid cell.
 */

import React, { useState, useEffect, memo } from "react";
import KeywordInput from "../KeywordInput";
import { CustomCellEditorProps } from "@ag-grid-community/react";

const RelatedKeywordsEditor: React.FC<CustomCellEditorProps> = memo(
  ({ value, onValueChange, stopEditing }) => {
    const [keywords, setKeywords] = useState<string[]>(value || []);

    useEffect(() => {
      onValueChange(keywords);
    }, [keywords, onValueChange]);

    const handleKeyDownCapture = (
      e: React.KeyboardEvent<HTMLInputElement>,
      hasNewKeyword: boolean
    ) => {
      if (e.key === "Enter" && hasNewKeyword) {
        e.preventDefault();
      }
    };

    return (
      <div className="flex flex-wrap items-center w-full h-auto gap-2 pl-[--ag-grid-size] my-2">
        <KeywordInput
          keywords={keywords}
          setKeywords={setKeywords}
          placeholder="Inserisci le keyword separate da una virgola"
          onKeyDownCapture={handleKeyDownCapture}
        />
      </div>
    );
  }
);

export default RelatedKeywordsEditor;
